<template>
  <div class="light-duv-control">
    <div class="scene-option_item">
      <div class="scene-option_item_label">
        {{ $t('lastLight.brightness') }}:
      </div>
      <div class="scene-option_item_modal">
        <img
          class="control_icon"
          src="~@/assets/img/icon_set-03.png"
        >
        <el-slider
          v-model="lightProps"
          class="scene-option_slider light"
          :min="lightRange.Min"
          :max="100"
          @change="() => onValueChange('light')"
        />
        <img
          class="control_icon"
          src="~@/assets/img/icon_set-04.png"
        >
        <div class="scene-option_item_value">
          {{ lightProps }} %
        </div>
      </div>
    </div>
    <div
      v-if="showTemperature"
      class="scene-option_item"
    >
      <div class="scene-option_item_label">
        {{ $t('hcl.colorName') }}:
      </div>
      <div class="scene-option_item_modal">
        <img
          class="control_icon"
          src="~@/assets/img/icon_set-01.png"
        >
        <el-slider
          v-model="temperature"
          class="scene-option_slider temperature"
          :min="optionRange.temperature.Min"
          :max="optionRange.temperature.Max"
          @change="() => onValueChange('temperature')"
        />
        <img
          class="control_icon"
          src="~@/assets/img/icon_set-02.png"
        >
        <div class="scene-option_item_value">
          {{ temperature }}
        </div>
      </div>
    </div>
    <div
      v-if="showDuv"
      class="scene-option_item"
    >
      <div class="scene-option_item_label">
        DUV:
      </div>
      <el-slider
        v-model="duv"
        class="scene-option_slider duv"
        :min="optionRange.duv.Min"
        :max="optionRange.duv.Max"
        @change="() => onValueChange('duv')"
      />
      <div class="scene-option_item_value">
        {{ duv }}
      </div>
    </div>
  </div>
</template>

<script>
import { transLightToProp, transLightToValue } from '@/utils/actionsHandler';

export default {
  // inject: ["handleSelectionChange", "doCallActionFun","deleteCardFun"],
  props: {
    option: {
      type: Object,
      default: () => ({
        light: 255
      })
    },
    optionRange: {
      type: Object,
      default: () => ({
        light: {
          Max: 255,
          Min: 1
        },
        temperature: {
          Max: 12000,
          Min: 1800
        },
        duv: {
          Max: 8,
          Min: -8
        }
      })
    },
    showDuv: {
      type: Boolean,
      default: false
    },
    showTemperature: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      lightProps: 255,
      temperature: 4000,
      duv: -4,
      lightRange() {
        return {
          Min: 0,
          Max: 255,
        }
      }
    }
  },

  computed: {
    showValue() {
      return this.value;
    }
  },

  watch: {
    option(value) {
      this.initLight(value);
    },
    device() {
      // this.initOptionRange();
    }
  },

  mounted() {
    this.initLight(this.option);
  },

  methods: {
    onValueChange(type) {
      this.$emit('change', {
        type,
        payload: this.getValue()
      });
    },

    getValue() {
      const optionRange = this.optionRange;

      return {
        light: transLightToValue(this.lightProps, optionRange.light.Max), // Math.round(255 * (this.lightProps / 100)),
        lightProps: this.lightProps,
        temperature: this.temperature,
        duv: this.duv,
      }
    },

    initLight(value) {
      const optionRange = this.optionRange;
      const light = (value || { light: 255 }).light;
      const temperature = (value || { temperature: 4000 }).temperature;
      const parsedDuv = Number((value || {}).duv);

      this.lightProps = transLightToProp(light, optionRange.light.Max); // Math.round(light / optionRange.light.Max * 100);
      this.temperature = temperature;
      // option 缺 duv / DefaultValue 为空时 Number 会得到 NaN，滑条会直接显示 NaN
      this.duv = Number.isFinite(parsedDuv) ? parsedDuv : -4;
      this.lightRange = {
        Min: Math.round(optionRange.light.Min / optionRange.light.Max * 100),
        Max: 100
      }
    }
  },
};
</script>

<style lang="scss">
.scene-option {
  margin-bottom: 50px;

  &_item {
    display: flex;
    width: 400px;
    align-items: center;

    &_label {
      margin-right: 10px;
    }

    &_value {
      width: 40px;
      margin-left: 10px;
    }

    &_modal {
      display: flex;  
      align-items: center;
    }
  }

  &_slider {
    flex: 1;
    min-width: 200px;
    margin-left: 10px;
    margin-right: 16px;

    .el-slider__bar {
      background: transparent
    }

    &.light {
      .el-slider__runway {
        background: linear-gradient(to right, #e5f0fc, #619df1);
      }
    }

    &.temperature {
      .el-slider__runway {
        background: linear-gradient(to right, #e5dd44, #fff, #619df1);
      }
    }

    &.duv {
      min-width: 218px;
      max-width: 218px;

      .el-slider__runway {
        background: linear-gradient(to right, #EF8A7F, #FFFFFF,#D8E2A6);
      }
    }
  }
}

.control_icon {
  width: 18px;
  height: 18px;
}
</style>